import { AlertTriangle, Loader2 } from 'lucide-react'
import { Button } from '@/components/ds2'

interface VehicleDocumentRemovalAlertProps {
    fileName: string
    busy: boolean
    onRetry: () => void
}

/** A failed private-file deletion is not a completed removal and must stay actionable after refresh. */
export const VehicleDocumentRemovalAlert = ({ fileName, busy, onRetry }: VehicleDocumentRemovalAlertProps) => (
    <div
        role="alert"
        className="flex w-full min-w-0 flex-wrap items-center gap-2 rounded-xl bg-warning-soft p-2 text-warning-soft-foreground"
        onClick={(event) => event.stopPropagation()}
    >
        <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
        <div className="min-w-0 flex-1 text-xs">
            <p className="truncate font-medium">{fileName}: removal incomplete</p>
            <p>The private file may still exist. Retry removal to finish.</p>
        </div>
        <Button
            type="button"
            variant="dangerSoft"
            size="sm"
            aria-label={`Retry removal of ${fileName}`}
            disabled={busy}
            prefix={busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : undefined}
            onClick={onRetry}
        >
            Retry removal
        </Button>
    </div>
)
